<template>
    <div :class="'navigation ' + (linksOpen ? 'open' : '')"  @click="linksToggle">
        <div class="navigation-toggle">
            <div class="icon">
                <svg width="28" height="25" viewBox="0 0 28 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.99927 4.00002H25.3993C26.3993 4.00002 27.1992 3.20002 27.1992 2.20002C27.1992 1.20002 26.3993 0.400024 25.3993 0.400024H1.99927C0.999268 0.400024 0.199219 1.20002 0.199219 2.20002C0.199219 3.20002 1.09927 4.00002 1.99927 4.00002Z" fill="#39414E"/>
                    <path d="M1.99927 14.3001H18.6992C19.6992 14.3001 20.4993 13.5001 20.4993 12.5001C20.4993 11.5001 19.6992 10.7001 18.6992 10.7001H1.99927C0.999268 10.7001 0.199219 11.5001 0.199219 12.5001C0.199219 13.5001 1.09927 14.3001 1.99927 14.3001Z" fill="#39414E"/>
                    <path d="M25.4993 21.1H1.99927C0.999268 21.1 0.199219 21.9 0.199219 22.9C0.199219 23.9 0.999268 24.7 1.99927 24.7H25.3993C26.3993 24.7 27.1992 23.9 27.1992 22.9C27.1992 21.9 26.3993 21.1 25.4993 21.1Z" fill="#39414E"/>
                </svg>
            </div>

            <div class="toggler">
                <SvgChevronDownToggler />
            </div>
        </div>

        <!-- navigazione VIVAMOD -->
        <ul class="navigation-links">

            <li><a :href="vivamodHost">Prenota!</a></li>
            <li><router-link :to="{name: 'blog'}">Blog</router-link></li>
            <li><a :href="vivamodHost + 'covid-19'">Covid-19</a></li>
            <li><a :href="vivamodHost + 'informazioni#perche-scegliere-vivamod'">Perchè prenotare con Vivamod</a></li>
            <!--<li><a :href="vivamodHost + 'metodi-pagamento'">Buoni sconto e tickets</a></li>-->
            <li><a :href="vivamodHost + 'faq'">Domande frequenti</a></li>
            <li><a :href="vivamodHost + 'informazioni'">Chi siamo</a></li>
            <li><a :href="vivamodHost + 'informazioni#assistenza'">Contatti</a></li>

        </ul>

    </div>
</template>

<script>
    import SvgChevronDownToggler from '@/components/svg/chevron-down-toggler'
    
    export default {
        name: 'navigation',
        components:
        {
            SvgChevronDownToggler,
        },
        data()
        {
            return {
                linksOpen: false,
                vivamodHost: process.env.VUE_APP_VIVAMOD_HOST,
            }
        },
        methods:
        {
            linksToggle(e)
            {
                e.stopPropagation()
                this.linksOpen = !this.linksOpen
                return false
            }
        },
        created()
        {
            window.addEventListener('scroll', () => {
                this.linksOpen = false
            })
            document.addEventListener('click', () => {
                this.linksOpen = false
            })
        },
    }
</script>

<style lang="scss">
    @import "~bootstrap/scss/functions";
    @import "~bootstrap/scss/mixins";
    @import './../../../scss/_custom.scss';

    .navigation
    {
        cursor: pointer;
        font-size: 16px;
        a
        {
            color:#157ffb;
        }

        ul,li
        {
            list-style:none;
            margin:0;
            padding:0;
        }
        
        .navigation-toggle
        {
            display: none;
        }

        .toggler
        {
            path
            {
                transition: $transition-base;
                transform-origin:center center;
            }
        }

        .icon
        {
            margin-left:10px;
            svg
            {
                width:auto;
            }
        }

        @include media-breakpoint-up(lg)
        {
            position:relative;
            .navigation-toggle
            {
                display: flex;
                align-items:center;
            }
            .navigation-links
            {
                display: none;
                position:absolute;
                top:100%;
                right:0;
                margin-top:2rem;
                background:$white;
                padding:$border-radius-lg;
                border-radius:$border-radius-lg;
                li
                {
                    white-space:nowrap;
                }
            }

            &.open
            {
                .toggler .arrow
                {
                    transform:rotate(180deg);
                }
                .navigation-links
                {
                    display:block;
                }
            }
        }
    }
</style>